module.exports = __webpack_public_path__ + "media/packs/images/flags/JO-f3c68f3e0aab24f4034baa7c7fec2610.svg";